// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, defineMessages } from "react-intl";

import { IAction } from "actions";
import { IState } from "states/states";
import { IOcppChargingSession, IRfid } from "states/ocppstates";

import IconRfid from "icons/navRfid";
import Rfid, { RfidStatus } from "model/rfid";

interface IRfidStatisticsProps {
  rfids: IRfid[];
  pendingSession: IOcppChargingSession[];
}

const mapStateToProps = (state: IState) => {
  const props: IRfidStatisticsProps = {
    rfids: state.ocpp.rfid,
    pendingSession: state.ocpp.pendingChargingSession,
  };
  return props;
};

interface IRfidStatisticsDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IRfidStatisticsDispatch = {};
  return dispatchProps;
};

const messages = defineMessages({});

class RfidStatisticsComponent extends React.Component<
  IRfidStatisticsProps & IRfidStatisticsDispatch
> {
  public render() {
    // these items are potential row entries
    const statEntries = [RfidStatus.AVAILABLE, RfidStatus.CHARGING, RfidStatus.EXPIRED];
    const statCount: number[] = Array(statEntries.length).fill(0);

    // loop through all connectors
    this.props.rfids.forEach((curRfid, curIndex) => {
      if (curRfid.isActive) {
        const pendingSession = this.props.pendingSession.find(
          (curItem) => curItem.rfid === curRfid.rfid,
        );
        const status = new Rfid(curRfid, pendingSession).getStatus();
        statCount[status] += 1;
      }
    });

    const rows = statEntries.map((curStat, curIndex) => {
      return (
        <tr key={curStat ?? "undefined"}>
          <td>{this.renderStatusIcon(curStat)}</td>
          <td className="right" style={{ paddingRight: 0 }}>
            {statCount[curIndex]}
          </td>
          <td>
            {curStat === RfidStatus.AVAILABLE ?
              <FormattedMessage id="Available" />
            : curStat === RfidStatus.CHARGING ?
              <FormattedMessage id="Charging" />
            : <FormattedMessage id="Expired" />}
          </td>
        </tr>
      );
    });

    return (
      <>
        <div id="rfidstatistics">
          <div id="rfidstatisticsframe">
            <table>
              <tbody>{rows}</tbody>
            </table>
            <div>
              <IconRfid />
            </div>
          </div>
        </div>
      </>
    );
  }

  private renderStatusIcon(status: RfidStatus) {
    const color = Rfid.getStatusColor(status);
    return (
      <div style={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: color }}></div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RfidStatisticsComponent);
